import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, from } from 'rxjs';
import { catchError,  map } from 'rxjs/operators';

export type INPIRecord = any;

@Injectable()
export class INPIService {

  constructor(private http: HttpClient) {}

  findBySiren(siren: string): Observable<INPIRecord> {
    return this.http
    .get(`/inpi/search/${siren}`)
    .pipe(map(data => {
      // console.log(data['record'].mappedData.societe);
      
      return data['record'];
    }))
    .pipe(catchError((err:any) => from(null)));
  }
}
